// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"da995977","44":"57e3d1c3","53":"3f7826c3","182":"a72bd8c3","237":"7041a7d7","350":"c0267867","449":"16b36b00","472":"0e97e54b","495":"f953de7b","638":"07de142d","653":"37dccf7b","891":"0f650885","930":"79154606","936":"4d1b059f"}[chunkId] + ".chunk.js";
};